@if (!responsive.isMobileSignal()) {
  <app-img-header
    [title]="getTitle()"
    [subTitle]="getSubtitle()"
    hasSubTitle="true"
    [config]="config()"
    [progressDetails]="getProgressDetails()"
    alt="Daimler Truck"
    image="/assets/images/cotizador/intro.jpg"
  >
  </app-img-header>
} @else {
  <app-img-header-mobile
    [title]="getTitle()"
    [subTitle]="getSubtitle()"
    hasSubTitle="true"
    [config]="config()"
    [progressDetails]="getProgressDetails()"
    alt="Daimler Truck"
    image="/assets/images/cotizador/intro.jpg"
  >
  </app-img-header-mobile>
}
@if (isLoading) {
  <app-preloader></app-preloader>
}
<app-notifications></app-notifications>
<main class="main" id="quotationOpen">
  <div id="detail" class="white">
    <div class="pageWidth">
      <form action="" [formGroup]="form">
        <div style="margin-bottom: 25px">
          @if (!responsive.isMobileSignal()) {
            <app-financial-service
              formGroupName="financialService"
              [financialService]="financialService()"
              [userId]="userId"
              [userName]="userName"
              [isModeEdition]="isModeEdition"
              [readOnlyByTerminalStatus]="readonlyFinanceAndDeals"
              [allowStatusApproveFromReview]="showApproveQuoteButton"
              [proposals]="deals"
            ></app-financial-service>
          } @else {
            <app-financial-service-mobile
              formGroupName="financialService"
              [financialService]="financialService()"
              [userId]="userId"
              [userName]="userName"
              [isModeEdition]="isModeEdition"
              [readOnlyByTerminalStatus]="readonlyFinanceAndDeals"
              [allowStatusApproveFromReview]="showApproveQuoteButton"
              [proposals]="deals"
            ></app-financial-service-mobile>
          }
        </div>
        <div>
          @if(!responsive.isMobileSignal()){
          <app-client-open
            formControlName="customer"
            [customer]="form.get('customer')?.value"
            [deals]="deals"
            [userId]="userId"
            [isModeEdition]="isModeEdition"
            [quoteContentReadOnly]="forceReadOnlyView || readonlyClientSection || linkedToCreditRequest"
            [customerIdSaved]="customerId"
            (editingStarted)="handleEditingStarted($event)"
            (selectedCustomerId)="handleSelectedCustomerId($event)"
          ></app-client-open>
          }@else {
          <app-client-open-mobile
            formControlName="customer"
            [customer]="form.get('customer')?.value"
            [deals]="deals"
            [userId]="userId"
            [isModeEdition]="isModeEdition"
            [quoteContentReadOnly]="forceReadOnlyView || readonlyClientSection || linkedToCreditRequest"
            [customerIdSaved]="customerId"
            (editingStarted)="handleEditingStarted($event)"
            (selectedCustomerId)="handleSelectedCustomerId($event)"
          ></app-client-open-mobile>
          }
        </div>

        <div>
          <app-deals
            [quoteType]="this.quoteType"
            [customer]="form.get('customer')?.value"
            [userId]="userId"
            [idQuote]="id"
            [nameCompany]="this.form.get('financialService.companyName')?.value ?? this.form.get('companyName')?.value"
            [financialService]="financialService()"
            [isModeEdition]="isModeEdition"
            [proposalsReadOnly]="forceReadOnlyView || readonlyFinanceAndDeals || linkedToCreditRequest"
            [proposals]="deals"
            [isValid]="isValid"
            (changeModeEdition)="changeMode($event)"
            (createDraft)="saveQuote($event)"
            (selectedDealEvent)="verifySelectedDeal()"
            #dealsCmp
          ></app-deals>
        </div>
        <div class="textareaWrapper comment" *ngIf="!isModeEdition && !readonlyFinanceAndDeals">
          <label for="comment">Comentario</label>
          <textarea id="comment" formControlName="comments" (keypress)="withoutSpecialCharacters($event)"></textarea>
        </div>
      </form>
      <div class="quotationActions index" *ngIf="!isModeEdition">
        <button class="secondary" (click)="cancel()">
          {{ userId == null || userId == authService.currentUserIds ? 'Cancelar' : 'Volver' }}
        </button>
        <button
          class="secondary"
          (click)="updateQuote(deals, true)"
          [disabled]="
            deals.length == 0 ||
            !isSelectedDeal ||
            id === 0
          "
        >
          Descargar PDF
        </button>
        @if (showExtendValidityBanner()) {
          <button
            type="button"
            class="secondary"
            (click)="openExtendValidityConfirmModal()"
            [disabled]="extendingValidity"
          >
            {{ extendingValidity ? 'Extendiendo…' : 'Extender vigencia' }}
          </button>
        }
        <button
          *ngIf="showBtn() && showApproveQuoteButton"
          class="primary"
          type="button"
          (click)="approveQuote()"
        >
          Aprobar cotización
        </button>
        <button
          *ngIf="showBtn() && showSaveButton"
          class="primary"
          (click)="save()"
          [disabled]="
            !(
              form.get('financialService')?.valid &&
              form.get('customer')?.valid &&
              deals.length > 0 &&
              id !== 0 &&
              form.get('financialService.dealerBranchId')?.value !== null
            )
          "
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</main>
<ng-template #extendValidityModalTemplate>
  <app-template-confirmation
    [title]="extendValidityModal.title"
    [subtitle]="extendValidityModal.subtitle"
    [btn1]="extendValidityModal.btn1"
    [btn2]="extendValidityModal.btn2"
    (closeModal)="closeExtendValidityConfirmModal()"
    (actionBtn2)="confirmExtendValidityFromModal()"
  ></app-template-confirmation>
</ng-template>
